export default __webpack_public_path__ + "static/media/airline_miles_light.72d18b26.png";